export interface NavLink {
  label: string;
  href: string;
}

export interface StatItem {
  value: string;
  label: string;
}

export interface ProcessStep {
  index: string;
  title: string;
  desc: string;
  icon: string;
}

export interface StandardItem {
  title: string;
  desc: string;
  icon: string;
}

export interface TimelineRow {
  stage: string;
  duration: string;
  detail: string;
}

export interface CategoryItem {
  name: string;
  desc: string;
  count: string;
  icon: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface TestimonialItem {
  quote: string;
  author: string;
  role: string;
}

export const navLinks: NavLink[] = [
  { label: "曝光流程", href: "#process" },
  { label: "审核标准", href: "#standards" },
  { label: "发布规则", href: "#rules" },
  { label: "处理时长", href: "#timeline" },
  { label: "主题分类", href: "#categories" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export const heroStats: StatItem[] = [
  { value: "24h", label: "初审响应时效" },
  { value: "5", label: "核心审核标准" },
  { value: "3", label: "轮人工交叉复核" },
  { value: "全程", label: "处理进度可查" },
];

export const processSteps: ProcessStep[] = [
  {
    index: "01",
    title: "提交投稿",
    desc: "选择主题分类，填写事件概述并上传可印证的证据材料，提交成功后即时获得唯一的查询编号。",
    icon: "ri-send-plane-line",
  },
  {
    index: "02",
    title: "合规初审",
    desc: "审核团队核对事件真实性、隐私信息遮蔽与法律风险，24 小时内给出初步结论并同步至查询编号。",
    icon: "ri-file-search-line",
  },
  {
    index: "03",
    title: "多方复核",
    desc: "对涉及他人的内容进行交叉核验，必要时联系投稿人补充说明，减少单一来源带来的偏差。",
    icon: "ri-shield-check-line",
  },
  {
    index: "04",
    title: "发布与跟进",
    desc: "通过审核的内容按分类与排期发布；未通过的会标明具体原因，补充材料后可重新提交。",
    icon: "ri-article-line",
  },
];

export const standards: StandardItem[] = [
  {
    title: "真实性核验",
    desc: "事件的时间、地点、主体与所述情节需前后一致，来源可追溯，不接受道听途说与主观推测。",
    icon: "ri-focus-3-line",
  },
  {
    title: "证据完整度",
    desc: "至少提供一项可印证材料，如文字记录、截图、票据或音视频，匿名来源需说明获取方式。",
    icon: "ri-attachment-2",
  },
  {
    title: "时效相关性",
    desc: "优先处理近两年内发生、且仍在持续或对公共讨论具有现实影响的事件。",
    icon: "ri-timer-line",
  },
  {
    title: "隐私与法律合规",
    desc: "遮蔽与事件无关的第三方个人信息，不涉及未成年人隐私、医疗记录与未生效的司法结论。",
    icon: "ri-lock-2-line",
  },
  {
    title: "表达与格式规范",
    desc: "事实陈述与个人观点需明确区分，禁止辱骂、歧视、煽动性用语以及诱导性的标题。",
    icon: "ri-edit-2-line",
  },
  {
    title: "公共利益关联",
    desc: "内容需与消费者权益、劳动权益、公共安全或行业规范存在实质关联，而非私人恩怨。",
    icon: "ri-scales-3-line",
  },
];

export const publishRules: string[] = [
  "通过审核的内容将按主题分类归档，并标注“已核验”“待补充证据”等状态标签，供读者判断信息完整度。",
  "涉及多方当事人的内容，同步展示各方的回应或说明入口，避免只呈现单方叙述。",
  "发布标题由编辑团队统一拟定，投稿原文以摘要形式呈现，确保标题与事实一致、不夸大。",
  "已发布内容的补充材料与更正说明，以显式标注的更新记录呈现，不直接覆盖原文。",
  "存在争议的内容不在搜索与推荐位做加权处理，读者需主动进入详情页查看。",
  "每篇内容保留原始提交编号，投稿人可随时凭编号查询处理进度与当前状态。",
];

export const removalReasons: string[] = [
  "证据被判定为伪造、拼接，或来源无法追溯且无法补充说明。",
  "当事人提供有效反驳材料，且原内容的事实基础被推翻。",
  "内容涉及未满十八周岁的当事人，或暴露与事件无关的第三方隐私信息。",
  "收到生效的司法裁判、行政机关通知，或权利人依法提出的删除要求。",
  "事件已过时效，不再具备公共讨论价值与持续关注意义。",
  "投稿人主动撤回并提交书面撤稿说明。",
];

export const timelineRows: TimelineRow[] = [
  { stage: "提交受理", duration: "即时", detail: "提交成功后立即生成查询编号" },
  { stage: "合规初审", duration: "24 小时内", detail: "核对真实性、隐私与法律风险" },
  { stage: "多方复核", duration: "3–5 个工作日", detail: "交叉核验并联系补充材料" },
  { stage: "编辑排期", duration: "1–3 个工作日", detail: "拟定标题、归档分类、安排发布" },
  { stage: "发布上线", duration: "排期当日", detail: "发布后 24 小时内接受更正申请" },
  { stage: "复审与更正", duration: "5 个工作日内", detail: "处理反驳材料与更正请求" },
];

export const categories: CategoryItem[] = [
  {
    name: "消费与维权",
    desc: "商品质量、售后纠纷、预付卡与虚假宣传等消费类线索。",
    count: "128 条",
    icon: "ri-shopping-bag-3-line",
  },
  {
    name: "职场与用工",
    desc: "拖欠薪资、违规加班、招聘承诺与实际不符等用工问题。",
    count: "96 条",
    icon: "ri-briefcase-4-line",
  },
  {
    name: "餐饮与食品安全",
    desc: "后厨卫生、食材来源、标签标识与门店经营规范相关内容。",
    count: "74 条",
    icon: "ri-restaurant-2-line",
  },
  {
    name: "房产与租住",
    desc: "押金退还、合同条款争议、中介服务与房屋质量类线索。",
    count: "63 条",
    icon: "ri-home-4-line",
  },
  {
    name: "教育培训",
    desc: "课程退费、师资宣传、招生承诺与机构经营状况相关问题。",
    count: "51 条",
    icon: "ri-graduation-cap-line",
  },
  {
    name: "网络与平台服务",
    desc: "平台规则、账号处理、自动续费与个人信息使用争议。",
    count: "82 条",
    icon: "ri-global-line",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "投稿之后，多久可以知道审核结果？",
    a: "提交成功后系统会立即生成查询编号，合规初审将在 24 小时内给出初步结论；完整的多方复核通常需要 3–5 个工作日，期间可凭编号随时查询当前状态。",
  },
  {
    q: "我可以匿名投稿吗？",
    a: "可以。匿名投稿时需在材料中说明信息来源与获取方式，便于审核团队判断可信度。除非法律法规另有要求，投稿人身份信息不会随内容公开。",
  },
  {
    q: "为什么我的投稿会被拒绝？",
    a: "常见原因包括证据不足、来源无法追溯、涉及与事件无关的第三方隐私，或含有辱骂与煽动性表达。系统会标明具体原因，补充材料后即可重新提交。",
  },
  {
    q: "已发布的内容可以修改或删除吗？",
    a: "可以。当事人可提交反驳或更正材料，平台会在复审后以“更新记录”的方式标注修改；符合删除条件的内容将被下架，并在原链接位置公示删除原因。",
  },
  {
    q: "投稿会公开我的真实身份吗？",
    a: "不会。投稿人身份信息默认不公开，内容中涉及的个人信息也会按要求做必要遮蔽处理，仅保留与事件直接相关的部分。",
  },
  {
    q: "审核标准会随时间变化吗？",
    a: "会。审核标准与发布规则会随法律法规和行业规范持续更新，重大调整将在本页“更新说明”中公示，并同步至投稿提交页。",
  },
];

export const testimonials: TestimonialItem[] = [
  {
    quote:
      "第一次投稿不太清楚要准备什么材料，这页把流程和标准写得比较清楚，补充材料时也有编号可以对应查询。",
    author: "王先生",
    role: "投稿人",
  },
  {
    quote:
      "内容里会标注证据状态和各方回应，读起来比单纯的情绪化爆料更让人愿意相信。",
    author: "林女士",
    role: "读者",
  },
  {
    quote:
      "收到通知后我提交了说明材料，平台在几个工作日内给出了复审结果，整个过程是可以追踪的。",
    author: "周先生",
    role: "被提及方",
  },
];

export const brandPrinciples: string[] = [
  "事实优先：先核验事实，再讨论观点，避免结论先行。",
  "隐私边界：与事件无关的个人信息，一律遮蔽处理。",
  "可修正：接受反驳与更正，保留完整的更新记录。",
  "不煽动：不使用诱导性标题，不放大对立与情绪。",
];

export const contactInfo = {
  brand: "黑料投稿审核中心",
  email: "shenhe@hl-tougao.com",
  replyTime: "工作日内 24 小时回复",
  followUp: "投稿进度请凭查询编号跟进",
};